import { IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function DocumentUploadDialogTitle({ title = "Add File", titleIcon = "ic:round-add", onClose }) {
    return (
        <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
                {titleIcon && <Iconify icon={titleIcon} sx={{ width: 24, height: 24 }} />}
                <Typography variant="h6">{title}</Typography>
            </Stack>
            <IconButton aria-label="Close" onClick={onClose} edge="end">
                <Iconify icon="ic:round-clear" />
            </IconButton>
        </Stack>
    )
}
